import React from "react";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import ProductCard from "./ProductCard";

const BothVariationCard = ({ item }) => {
  const [selectedType, setselectedType] = useState("");
  let OneSizes = item.variations[0].variations;
  const [SizeVars, setSizeVars] = useState(OneSizes);

  return (
    <ProductCard
      item={item}
      children={
        <Box style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
            }}
          >
            Colors :
            {item.variations.map((el) => (
              <button
                key={el._id}
                style={{
                  background: el.color,
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: selectedType == el.color ? "3px solid black" : "none",
                }}
                onClick={() => {
                  setselectedType(el.color);
                  setSizeVars(el?.variations);
                  // setfeaturedImage(el?.images?.featuredImage?.src);
                }}
              ></button>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              wrap: "wrap",
            }}
          >
            {SizeVars.map((el) => (
              <button
                key={el._id}
                style={{
                  background: el.size,
                  width: "45px",
                  height: "25px",
                  borderRadius: "0",
                  border:
                    selectedType == el.size
                      ? "3px solid black"
                      : "1px solid black",
                }}
                onClick={() => {
                  setselectedType(el.size);
                  // setfeaturedImage(el?.images?.featuredImage?.src);
                }}
              >
                {el?.size?.toUpperCase()}
              </button>
            ))}
          </div>
        </Box>
      }
    />
  );
};

export default BothVariationCard;
